import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TargetBlankDirective } from '@app/core/misc/directives/target-blank.directive';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TargetBlankDirective],
})
export class SocialLinksComponent {
  @Input()
  classes: string = '';

  protected environment = environment;
}
